import { get } from 'lodash';
import { TPlanDetails, TPricingPlans } from './types';

export const transformPlanDetails = (
  planDetails: Partial<TPlanDetails> | undefined
): TPlanDetails => {
  return {
    price: get(planDetails, 'price', 0),
    name: get(planDetails, 'name', ''),
    listingId: get(planDetails, 'listingId', ''),
    planId: get(planDetails, 'planId', ''),
    seoSlug: get(planDetails, 'seoSlug', ''),
    shortDescription: get(planDetails, 'shortDescription', ''),
    productServiceType: get(planDetails, 'productServiceType', ''),
    servicesIncluded: get(planDetails, 'servicesIncluded', []),
    whenRequired: get(planDetails, 'whenRequired', []),
    offerPricing: {
      originalPrice: get(planDetails, 'offerPricing.originalPrice', 0),
      discountPercentage: get(
        planDetails,
        'offerPricing.discountPercentage',
        0
      ),
    },
    pricing: {
      listPriceWithGST: get(planDetails, 'pricing.listPriceWithGST', 0),
      listPrice: get(planDetails, 'pricing.listPrice', 0),
      discountedPrice: get(planDetails, 'pricing.discountedPrice', 0),
      tax: get(planDetails, 'pricing.tax', 0),
      totalAmount: get(planDetails, 'pricing.totalAmount', 0),
      roundedAmount: get(planDetails, 'pricing.roundedAmount', 0),
      roundedTax: get(planDetails, 'pricing.roundedTax', 0),
    },
  };
};
export const transformPricingPlans = (
  pricingPlans: Array<Partial<TPricingPlans>>
): Array<TPricingPlans> => {
  if (!Array.isArray(pricingPlans)) return [];
  return pricingPlans.map((plan) => ({
    externalId: get(plan, 'externalId', ''),
    planDetails: transformPlanDetails(plan.planDetails),
    autoApplicableCoupon: get(plan, 'autoApplicableCoupon', null),
  }));
};
